import React, { useState, useEffect, useCallback } from 'react';
import { AlertTriangle, X, ChevronRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BillingAlertBanner = ({ onNavigateToRecouvrement }) => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);
  const fetchAlerts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/admin/dashboard/billing-alerts`, {});
      setData(res.data);
    } catch (err) {
      console.error('Billing alerts error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchAlerts(); }, [fetchAlerts]);

  if (loading || dismissed || !data?.hasAlerts) return null;

  const spotCount = data.spotWithoutInvoice?.count || 0;
  const contractCount = data.contractsWithoutMonthlyInvoice?.count || 0;
  const totalAlerts = spotCount + contractCount;

  if (totalAlerts === 0) return null;

  return (
    <div
      className="flex items-center justify-between h-10 px-4 bg-amber-50 border border-amber-200 mb-4"
      data-testid="global-billing-alert-banner"
    >
      <div className="flex items-center gap-2.5">
        <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0" />
        <span className="text-sm font-medium text-amber-900">
          {totalAlerts} incohérence{totalAlerts > 1 ? 's' : ''} détectée{totalAlerts > 1 ? 's' : ''}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <button
          onClick={onNavigateToRecouvrement}
          className="flex items-center gap-1 text-xs font-semibold text-amber-800 hover:text-amber-950 transition-colors"
          data-testid="billing-alert-see-details"
        >
          Voir les détails
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="p-0.5 text-amber-400 hover:text-amber-700 transition-colors"
          data-testid="billing-alert-dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default BillingAlertBanner;
